// constants
import { showSuccessAlert } from "../../constants/alerts";
import { UserActionTypes } from "./constants";

const INIT_STATE = {
  users: [],
  maxDeviceCount: null,
  loading: false,
  initialLoading: false,
  error: null,
};

// interface whoAreWeData {
//   id: number;
//   experience: string;
//   users: string;
//   courses: string;
// }

interface UserActionType {
  type:
    | UserActionTypes.API_RESPONSE_SUCCESS
    | UserActionTypes.API_RESPONSE_ERROR
    | UserActionTypes.UPDATE_USER_STATUS
    | UserActionTypes.GET_USER_DATA;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
    whoAreWeData?: [];
  };
}

// interface State {
//   whoAreWeData?: whoAreWeData[] | [];
//   loading?: boolean;
//   value?: boolean;
// }

const Users = (state: any = INIT_STATE, action: UserActionType): any => {
  switch (action.type) {
    case UserActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case UserActionTypes.GET_USER_DATA: {
          return {
            ...state,
            users: action.payload.data.users,
            maxDeviceCount: action.payload.data.maxDeviceCountinDb,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case UserActionTypes.UPDATE_USER_STATUS: {
          
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case UserActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case UserActionTypes.GET_USER_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case UserActionTypes.UPDATE_USER_STATUS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case UserActionTypes.GET_USER_DATA:
      return { ...state, loading: true, initialLoading: true };
    case UserActionTypes.UPDATE_USER_STATUS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Users;
